import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c93828f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-left" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "sidebar-title" }
const _hoisted_6 = { class: "trailer-results-listing" }
const _hoisted_7 = { class: "trailer-results-footer sidebar-footer" }
const _hoisted_8 = {
  key: 0,
  class: "h-100 d-flex align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocationTrailerResultCard = _resolveComponent("LocationTrailerResultCard")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "icon-container back-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigateBack')))
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.results[0].locationName), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result, index) => {
        return (_openBlock(), _createBlock(_component_LocationTrailerResultCard, {
          key: index,
          result: result,
          id: result.trailers[0].id
        }, null, 8, ["result", "id"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.trailerAssociationsEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_fbx_button, {
              class: "italic",
              "button-text": "Attach Another Trailer",
              theme: "link",
              onClick: _ctx.navigateToEnterTrailer
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}